<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import type { NodeData, NodeType } from '../types/flow-types';

	export let id: string;
	export let type: NodeType = 'condition';
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];
	/** When true, only the green “if true” source is shown (e.g. Device Check). */
	export let hideFalseOutput: boolean = false;

	export let cardTitle: string | undefined = undefined;
	export let cardDescription: string | undefined = undefined;
	export let nodeTypeLabel: string | undefined = undefined;
	export let badge: string | undefined = undefined;
	export let labelList: { icon?: string; value?: string; iconColor?: string }[] | undefined =
		undefined;

	$: branchOutputs = hideFalseOutput ? ('true-only' as const) : ('true-false' as const);
</script>

<BaseNode
	{id}
	{type}
	{data}
	{selected}
	{validated}
	{errors}
	{branchOutputs}
	hideOutputPort={true}
	{cardTitle}
	{cardDescription}
	{nodeTypeLabel}
	{badge}
	{labelList}
	{...$$restProps}
>
	<slot />
</BaseNode>
